export default __webpack_public_path__ + "static/media/lipide.18f60e0e.svg";